import { Component, Input } from '@angular/core';
import { AsyncDecorator } from '../../core-utilities/AsyncDecorator';
import { Util } from '../../core-utilities/Util';
import { TranslationService } from '../../translations';

@Component({
    selector: 'pi-copy-to-clipboard',
    template: `
        <div class="clipboardContainer">
            <div class="clipboardContainer_upper">
                <div class="clipboardContainer_title">
                    {{ clipboardTitle }}
                </div>
            </div>
            <div class="clipboardContainer_content">
                <div class="clipboardContainer_text">
                    <input
                        #textBox
                        type="text"
                        readonly
                        class="textBox"
                        [placeholder]="placeholderText"
                        [value]="data"
                    />
                </div>
                <div class="clipboardContainer_buttons">
                    <span
                        class="copiedMessage"
                        [ngClass]="{
                            displayMessage: showCopyMessage
                        }"
                    >
                        {{ TR.key('Copied') }}
                    </span>
                    <button
                        class="btn btn--lsg btn--lsg--primary btn--lsg--small"
                        (click)="copyToClipBoard()"
                    >
                        {{ buttonText }}
                    </button>
                </div>
            </div>
        </div>
    `,
    standalone: false
})
export class CopyToClipboardComponent {
    @Input()
    placeholderText: string;
    @Input()
    clipboardTitle: string;
    @Input()
    data: string;
    @Input()
    buttonText: string;

    showCopyMessage = false;

    constructor(
        public TR: TranslationService,
        private util: Util
    ) {}

    @AsyncDecorator.temporaryMark(function (
        this: CopyToClipboardComponent,
        value: boolean
    ) {
        this.showCopyMessage = value;
    }, 1500)
    copyToClipBoard() {
        this.util.copyStringToClipboard(this.data);
    }
}
